module.exports = __webpack_public_path__ + "img/men3.2ef18aff.png";